const NOISE_SVG = `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E")`;

export default function MeshBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(155deg, #7D2AE7 0%, #5C3FE8 32%, #3969E7 62%, #07B9CE 100%)",
        }}
      />
      <div
        className="absolute -top-[30%] -left-[20%] h-[80vmax] w-[80vmax] rounded-full opacity-70 blur-[120px]"
        style={{
          background:
            "radial-gradient(circle, rgba(125,42,231,0.9) 0%, rgba(125,42,231,0) 65%)",
        }}
      />
      <div
        className="absolute -bottom-[35%] -right-[25%] h-[85vmax] w-[85vmax] rounded-full opacity-60 blur-[130px]"
        style={{
          background:
            "radial-gradient(circle, rgba(7,185,206,0.75) 0%, rgba(7,185,206,0) 65%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(ellipse at 50% 38%, rgba(10,4,32,0.42) 0%, rgba(10,4,32,0) 55%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.05] mix-blend-overlay"
        style={{ backgroundImage: NOISE_SVG, backgroundSize: "180px 180px" }}
      />
    </div>
  );
}
